import {
    AtualizarStatusCobrancaService,
    BuscaStatusCobrancaService,
    GetAtendimentoService,
} from "../../Services/Cobranca/GestaoAtendimento/GestaoAtendimentoService";
import { ListarHistoricoClienteService } from "../../Services/Geral/Historicos/HistoricosService";
import { ValidationErr } from "../../Validations/ValidationError";
import { Controller } from "../Controller";

export async function AtendimentoController(ID_CASO: number) {
    const response = await GetAtendimentoService(ID_CASO)
        .then((response) => {
            return {
                ...response.data,
                ID_CHAVE_ERP_VENDA: `${response.data.ID_EMPRESA}_${response.data.DS_OBRA}_${response.data.NR_VENDA}`,
            };
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });

    return response;
}

export async function ListarHistoricoCliente(idConta: number) {
    const lstHistoricoAtendimento = await ListarHistoricoClienteService(idConta)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });

    return lstHistoricoAtendimento;
}

export async function BuscaStatusCobrancaController() {
    const lstStatusCobranca = await BuscaStatusCobrancaService()
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            ValidationErr(err);
            throw err;
        });

    return lstStatusCobranca;
}

export async function AtualizarStatusCobrancaController(
    ID_CHAVE_ERP: string,
    requestBody: [{ codigo: number }]
) {
    return Controller(
        AtualizarStatusCobrancaService(ID_CHAVE_ERP, requestBody)
    );
}
